export enum InventoryTypes {
  Artisanal = "Artisanal",
  Stocked = "Stocked",
  OnRequest = "OnRequest",
}
